import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
export default {
  props: {
    translationsLineDescription: {
      type: String,

      default() {
        return '';
      }

    },
    translationsLineName: {
      type: String,

      default() {
        return '';
      }

    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    lineDescription() {
      return this.translationsLineDescription;
    },

    urlLineName() {
      return this.buildSearchUrl(this.locale, this.translationsLineName);
    }

  })
};